import React from 'react';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Input from '../Symbols/Input';
import InputRadio from '../Symbols/InputRadio';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import Info from '../Symbols/Info';
import { genderOptions } from '../common/GenderOptions';
import styled from '@emotion/styled';

const emptyFunc = () => {};

const InputSuffix = styled('span')`
	flex-basis: 10%;
	padding: 10px 0;
	line-height: 20px;
`;

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { weight = 60, height = 170, age = 35, gender = 2 },
		bmr = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form
				onSubmit={onSubmit}
				title="Kalkulačka bazální metabolismus / Denní spotřeba kalorií (BMR)"
			>
				<Input
					type="number"
					label="Váše váha"
					onChange={changeHandler('weight')}
					onBlur={validateHandler('weight')}
					value={weight}
					name="weight"
					error={errors.weight}
					passedProps={{ 'data-cy': 'weight' }}
				>
					<InputSuffix>&nbsp;kg</InputSuffix>
				</Input>

				<Input
					type="number"
					label="Váše výška"
					onChange={changeHandler('height')}
					onBlur={validateHandler('height')}
					value={height}
					name="height"
					error={errors.height}
					passedProps={{ 'data-cy': 'height' }}
				>
					<InputSuffix>&nbsp;cm</InputSuffix>
				</Input>

				<Input
					type="number"
					label="Váš věk"
					onChange={changeHandler('age')}
					onBlur={validateHandler('age')}
					value={age}
					name="age"
					error={errors.age}
					passedProps={{ 'data-cy': 'age' }}
				>
					<InputSuffix>&nbsp;let</InputSuffix>
				</Input>

				<InputRadio
					label="Pohlaví"
					name="gender"
					radio={genderOptions}
					onChange={changeHandler('gender')}
					onBlur={validateHandler('gender')}
					value={gender}
					passedProps={{ 'data-cy': 'gender' }}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{bmr && <Result bmr={bmr} />}

				{bmr && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}

				<Info css={Row}>
					<p>
						Poznámka: Výpočet denní spotřeby kalorií je pouze orientační. Kalkulačka nezohledňuje
						všechny vaše denní aktivity. Skutečná denní kalorická spotřeba se tak může mírně
						odlišovat.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
